/**
 * Crypt Pawn Component Factory
 *
 * Creates color-specific crypt pawn components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * CryptPawnComponent with per-color gradient schemes.
 */

import React from 'react';
import type { PawnProps } from '../../constants/types';
import CryptPawnComponent from './CryptPawnComponent';
import { CRYPT_PAWN_COLOR_SCHEMES, type CryptPawnColorScheme } from './constants/pawnColorSchemes';

type PawnColor = 'red' | 'blue' | 'yellow' | 'green';

function createCryptPawn(color: PawnColor) {
  const colorScheme: CryptPawnColorScheme = CRYPT_PAWN_COLOR_SCHEMES[color];
  const displayName = `Crypt${color.charAt(0).toUpperCase() + color.slice(1)}Pawn`;

  const ColoredPawn = React.memo(function ColoredPawn(props: PawnProps) {
    return <CryptPawnComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredPawn.displayName = displayName;
  return ColoredPawn;
}

export const RedPawn = createCryptPawn('red');
export const BluePawn = createCryptPawn('blue');
export const YellowPawn = createCryptPawn('yellow');
export const GreenPawn = createCryptPawn('green');
